module.exports = __webpack_public_path__ + "static/img/banner_20231122.020ad32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/banner_20231122.png
// module id = 2fEz
// module chunks = 16